<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-kemu-copy"></i>
      签到列表
    </div>
    <div class="padding-sm">
      <el-table
          :data="sginList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          fit
          style="width: 100%"
      >
        <el-table-column label="试卷名称">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.title }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="试卷类型">
          <template slot-scope="scope">
            <div class="table-item">
              <span v-if="Number(scope.row.type)===1">基础知识</span>
              <span v-if="Number(scope.row.type)===2">实践案例</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="考试场次">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.number }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="考试时间">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.time }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                  size="medium"
                  type="primary"
                  @click="toItem(scope.row.type,scope.row.number,examName,scope.row.title)"
              >签到详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
import {signList} from "@/api/projectOffice";

export default {
  name: "examSign",
  data() {
    return {
      examName:'',
      sginList: [],

    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/examination',
        "当前位置：考试管理 > 签到列表",
        true
    );
    this.examName = this.$route.query.exam_name
    this.getList()
  },
  methods: {
    async getList() {
      let _list = await signList(this.$route.query.id)
      this.sginList = _list.data
    },
    toItem(type, num,title) {
      this.$router.push('/projectOffice/examSginDetail?examid=' + this.$route.query.id + '&type=' + type + '&number=' + num +'&exam_name='+this.examName +'&test_paper=' + title)
    }
  }
}
</script>

<style scoped lang="scss">

</style>